import React from 'react';
import Library from '@peoplenet/vi-components-ui/src/Library/container/Library';

const library = () => {
  return (
    <div className="bodycontent">
      <Library />
    </div>
  );
};

export default library;
